import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-lookup",
  "use": "rt-base-lookup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-lookup\">\n<path d=\"M905.2,861.2L796.2,752.2C854.7,684,890,595.3,890,498.5c0-215.5-174.7-390.3-390.3-390.3S109.5,282.9,109.5,498.5\n\ts174.7,390.3,390.3,390.3c95.6,0,183.2-34.4,251-91.4l109.2,109.2c6.2,6.2,14.4,9.4,22.6,9.4s16.4-3.1,22.6-9.4\n\tC917.7,893.9,917.7,873.7,905.2,861.2z M263.2,735c-63.2-63.2-98-147.2-98-236.5c0-89.3,34.8-173.3,98-236.5s147.2-98,236.5-98\n\ts173.3,34.8,236.5,98c63.2,63.2,98,147.2,98,236.5c0,87.8-33.6,170.3-94.7,233.1c-1.8,1.2-3.5,2.6-5.1,4.2c-1.5,1.5-2.9,3.2-4,4.9\n\tC667.9,800.2,586.4,833,499.7,833C410.4,833,326.4,798.2,263.2,735z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/lookup.svg
// module id = 1212
// module chunks = 96